import { gsap } from "gsap"
const modal = document.getElementById('modal');
const modalContainer = modal.querySelector('.modal-container');
const modalContentContainer = modal.querySelector('.modal-content-container');
const modalCloseBtn = modal.querySelector('.close-modal');
const modalCPTEls = document.querySelectorAll('[href*="/modal/"]'); //Elements with /modal/ in href
let modalTriggeredEl = ''; //This will be the element that triggers the modal, so we can reset focus to it after modal closes
let modalTL = gsap.timeline({defaults: {duration:0.15}});
const prefersReducedMotion = window.matchMedia(`(prefers-reduced-motion: reduce)`) === true || window.matchMedia(`(prefers-reduced-motion: reduce)`).matches === true;


// Open modal - populate modal content, add active class, animate display
const openModal = (modalContentNew, modalTheme = 'light') => {
    modalContentContainer.innerHTML = modalContentNew //Populate modal content
    //If prefers-reduced-motion display instantly via .active class addition, otherwise animate in with GSAP
    if (!!prefersReducedMotion) {
        modal.classList.add('active', `theme-${modalTheme}`)
    } else {
        modalTL.set(modal, {opacity:0})
        modalTL.call(() => { modal.classList.add('active', `theme-${modalTheme}`) })
        modalTL.to(modal, {opacity:1})
        modalTL.fromTo(modalContainer, {scale:0.95, opacity:0}, {scale:1, opacity:1}, '>-0.1')
    }
    modalTL.then(() => {
        modalContainer.focus() //Accessibility - Focus modal once active
        let modalVideo = modal.querySelector('iframe[src*="player.vimeo.com"]');
        if (!!modalVideo) {
            let player = new Vimeo.Player(modalVideo);
            player.play();
        }
    })
}


// Close modal - animate hide, remove active class, clear modal content
const closeModal = () => {
    // If prefers-reduced-motion hide instantly via .active class removal, otherwise animate out with GSAP
    if (!!prefersReducedMotion) {
        modal.className = ''; //Remove all classes so modal is not displayed, which also resets HTML scrolling by not having .active class on #modal
        modalContentContainer.innerHTML = "" //Clear modal content
    } else {
        modalTL.to(modalContainer, {scale:0.95, opacity:0})
        modalTL.to(modal, {opacity:0}, '>-0.05')
        modalTL.call(() => { modal.className = ''; }) //Remove all classes so modal is not displayed, which also resets HTML scrolling by not having .active class on #modal
        modalTL.call(() => { modalContentContainer.innerHTML = "" }) //Clear modal content
    }
    modalTL.then(() => { if (!!modalTriggeredEl) {modalTriggeredEl.focus()} }) //Accessibility - Focus element that triggered modal
}

// Close modal when clicking on modal background
modal.addEventListener('click', function(e) {
    if (e.target === modal) {
        closeModal()
    }
})
// Accessibility - Close modal with escape key
document.addEventListener('keyup', function(e) {
    if (e.key === 'Escape' && !!modal.classList.contains('active')) {
        closeModal()
    }
})
// Close modal with modal close button 
modalCloseBtn.addEventListener('click', () => {
    closeModal();
})


// Accessibility - Tab Guard (cannot tab outside modal while active)
modalContainer.addEventListener('keydown', (e) => {
    if (e.repeat) return;
    
    //If pressing tab + shift on modal container then focus the modal close button (which is last tabbable element in modal)
    if (e.key === 'Tab' && !!e.shiftKey && e.target === modalContainer) {
        e.preventDefault()
        modalCloseBtn.focus()
    }
})
modalCloseBtn.addEventListener('keydown', (e) => {
    if (e.repeat) return;

    //If pressing tab + not shift on modal close button then focus the modal container
    if (e.key === 'Tab' && !e.shiftKey) {
        e.preventDefault()
        modalContainer.focus()
    }
})


// Add modal activation listener to all modalTriggerEls
const addModalTriggerListener = () => {
    const modalTrigger = (e) => {
        e.preventDefault();
        let triggerEl = e.target;
            
        //Get the modal theme (light/dark), or fallback to light if none set
        let modalTheme = (!!triggerEl.hasAttribute('data-modal-theme') ? triggerEl.getAttribute('data-modal-theme') : 'light');

        //Go retrieve the referenced element and open the modal
        let modalContentNew = '';
        let triggerElDataModal = triggerEl.getAttribute('data-modal')
        if (!!triggerElDataModal) {
            modalContentNew = document.querySelector(triggerElDataModal).innerHTML;
            if (!!modalContentNew) {
                openModal(modalContentNew, modalTheme);
                modalTriggeredEl = triggerEl;
            }
        }
    }
    
    //Add listener to elements with non-empty data-modal attribute
    const modalTriggerEls = document.querySelectorAll('[data-modal]:not([data-modal=""]');
    if (!!modalTriggerEls.length) {
        for (let triggerEl of modalTriggerEls) {
            //Check if there is an attribute we set when the listener is added so we don't add multiple listeners
            if (!triggerEl.getAttribute('data-listener', true)) {
                triggerEl.addEventListener('click', modalTrigger)
                triggerEl.setAttribute('data-listener', true)
            }
        }
    }
}


// Helper function - retrieve CPT Modal content via REST API
async function getCPTModalContent(modalSlug) {
    let apiURL = `${window.location.origin}/wp-json/wp/v2/modal?slug=${modalSlug}`;
	try {
		const response = await fetch(apiURL);
		if (!response.ok) {
			throw new Error(`Response status: ${response.status}`);
		}

		const data = await response.json();
		return data;
	} catch (error) {
		console.error('Fetch error:', error.message);
	}
}
//If the trigger element references a modal CPT then go retrieve that via helper function and create element on the page, otherwise just call trigger listener
if (!!modalCPTEls.length) {
    for (let modalCPTEl of modalCPTEls) {
        let modalCPTElHREF = modalCPTEl.getAttribute('href')
        if (!!modalCPTElHREF && modalCPTElHREF.includes('/modal/')) {
            let modalSlug = modalCPTElHREF.replace(`${window.location.origin}/modal/`, '').replace('/', '');
            
            getCPTModalContent(modalSlug).then((data) => {
                // If the modal content doesn't exist on the page yet then create new div with content from the modal page
                if (!document.querySelector(`.${modalSlug}`)) {
                    let modalCPTContentEl = document.createElement('div');
                    modalCPTContentEl.classList.add(modalSlug)
                    modalCPTContentEl.setAttribute('style', 'display:none;');
                    modalCPTContentEl.innerHTML = data[0].content.rendered;
                    document.body.appendChild(modalCPTContentEl);
                }

                //Accessibility - Replace the <a> element with a <button> element since we're only opening a modal
                let modalBtnReplace = document.createElement('button');
                modalBtnReplace.textContent = modalCPTEl.textContent;
                modalBtnReplace.setAttribute('type', 'button');
                modalBtnReplace.setAttribute('class', modalCPTEl.getAttribute('class'));
                modalBtnReplace.setAttribute('data-modal', `.${modalSlug}`);
                modalBtnReplace.setAttribute('data-title', `Modal - ${modalCPTEl.textContent}`);
                modalCPTEl.replaceWith(modalBtnReplace);

                //Call trigger listener addition function
                addModalTriggerListener();
            });
        }
    }
} else {
    //Call trigger listener addition function
    addModalTriggerListener();
}